import type {BetterSystemStyleObject} from '@primer/react/lib-esm/sx'
import {Box, merge} from '@primer/react'
import {Children, isValidElement, type ReactNode} from 'react'
import {testIdProps} from '@github-ui/test-id-props'

import {useListViewVariant} from '../ListView/VariantContext'
import {ListItemTitle} from './Title'

const containerStyles: BetterSystemStyleObject = {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  gap: 3,
  paddingRight: 2,
  flexGrow: 1,
  overflow: 'hidden',
  gridArea: 'main-content',
}

const innerStyles: BetterSystemStyleObject = {
  display: 'flex',
  flexGrow: 1,
  height: '100%',
  flexShrink: 1,
  minWidth: '40%',
  overflow: 'hidden',
  flexDirection: 'column',
  gap: 0,
  alignItems: 'flex-start',
  pb: '10px',
}

const compactInnerStyles: BetterSystemStyleObject = {
  flexDirection: ['column', 'row'],
  gap: [0, 0, 1],
  justifyContent: ['center', 'flex-start'],
  alignItems: ['flex-start', 'center'],
  pb: undefined,
}

export function ListItemMainContent({children}: {children?: ReactNode}) {
  const {variant} = useListViewVariant()
  const childrenArray = Children.toArray(children)
  const titleIndex = childrenArray.findIndex(
    child => isValidElement(child) && typeof child !== 'string' && child.type === ListItemTitle,
  )
  const title = childrenArray[titleIndex]
  const nonTitleChildren =
    titleIndex < 0 ? childrenArray : childrenArray.slice(0, titleIndex).concat(childrenArray.slice(titleIndex + 1))
  return (
    <>
      {title}
      <Box {...testIdProps('list-view-item-main-content')} sx={containerStyles}>
        <Box sx={merge<BetterSystemStyleObject>(innerStyles, variant === 'compact' && compactInnerStyles)}>
          {nonTitleChildren}
        </Box>
      </Box>
    </>
  )
}

try{ ListItemMainContent.displayName ||= 'ListItemMainContent' } catch {}